/**
 * @desc 订单退款明细
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export type Response = defs.omsFlow.ResponseDto<Array<defs.omsFlow.AsRefundOrderItemResponseDto>>;
export function request(soOrderNo: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/systemOrderItem/refundItem/${soOrderNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
